import { KeyboardReturn } from '@mui/icons-material';
import React from 'react';
import { Fade } from 'react-reveal';
import { SkillsData } from '../data';
import ProgressBars from './progressBars';
import { useEffect } from 'react';
import { useState } from 'react';
import { HashLink } from 'react-router-hash-link';

function AllSkills({ setShowAllSkills }) {
    const [initialize, setInitialize] = useState(false)
    useEffect(() => {
        setInitialize(true)
        setTimeout(() => {
            setInitialize(false)

        }, 1500);
    }, [])
    return (
        <div className='px-3 fw-bold'>
            <Fade right>
                <div onClick={() => setShowAllSkills(false)} className=' mt-3 '>
                    <span>
                        <KeyboardReturn />
                    </span>
                    Hide
                </div>
                <br />
                <div className='skills-responsive'>
                    {
                        SkillsData.map((skill) => (
                            // <Fade key={skill.name} duration={3500}>
                            <div className='my-3'>

                                <div className='skill-display mt-4 mb-1'>
                                    <span className=''>{skill.name}</span>
                                    <span className='mx-1'><img src={skill.image} alt="..." /></span>

                                </div>
                                <div>
                                    <ProgressBars width={initialize ? 0 : skill.proficiency} />
                                </div>
                            </div>
                            // </Fade>
                        ))
                    }
                </div>
                <div onClick={() => setShowAllSkills(false)} className=' mt-5 '>
                    <HashLink smooth to="#skills" style={{color:'white', textDecoration:'none'}}>
                        <span>
                            <KeyboardReturn />
                        </span>
                        Hide
                    </HashLink >

                </div>
            </Fade>

        </div>
    );
}

export default AllSkills;